import { getDisplaySize } from "@lhd/components/DisplaySizeSelector/selector";
import { BUTTON_HEIGHT, FONT_SIZE, FONT_SIZE_VALUE } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

export type ReceivedProps = Record<string, any>;

export const CATEGORY_STATUS_TABS = {
  STAFF_TAX_SHEET: { key: "staff_tax_sheet", label: "給与明細/支払計算書" },
  BIZ_SHEET: { key: "biz_sheet", label: "Bizシート" },
  CUSTOMER: { key: "customer", label: "取引先情報" },
  COMPANY_POLICIES: {
    key: "company_policies",
    label: "社内規定・就業規則",
  },
  BUSINESS_MANUALS: {
    key: "business_manuals",
    label: "内部統制",
  },
  PROJECT_MANAGEMENT: {
    key: "project_management",
    label: "プロジェクト管理",
  },
  APPRAISALS: { key: "appraisals", label: "目標一覧" },
  APPRAISAL_SHEETS: { key: "appraisal_sheets", label: "評価シート一覧" },
  WORKERS: { key: "workers", label: "スタッフデータ・社員一覧" },
  BUSINESS_TRIP_REPORTS: {
    key: "business_trip_reports",
    label: "出張旅費報告・申請書",
  },
};

export const BUSINESS_MANUALS_SUB_TABS = {
  JOB_AUTHORITY_MATRIX: {
    key: "job_authority_matrix",
    label: "職務格限マトリクス",
  },
  BUSINESS_MANUALS: {
    key: "business_manuals",
    label: "業務マニュアル",
  },
  BUSINESS_FLOWCHART: {
    key: "business_flowchart",
    label: "業務フローチャート",
  },
};

const useCategoryStatusConfig = (props: ReceivedProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeKey, setActiveKey] = useState(CATEGORY_STATUS_TABS.WORKERS.key);
  const tabParams = searchParams.get("tab");
  const subTabParams = searchParams.get("sub_tab");
  const [businessManualSubTab, setBusinessManualSubTab] = useState(
    subTabParams || BUSINESS_MANUALS_SUB_TABS.BUSINESS_MANUALS.key,
  );

  const displaySize = useSelector(getDisplaySize) as
    | keyof typeof FONT_SIZE
    | keyof typeof BUTTON_HEIGHT;
  const height = BUTTON_HEIGHT[displaySize] ?? BUTTON_HEIGHT.small;
  const size = FONT_SIZE_VALUE[displaySize ?? DISPLAY_SIZES.SMALL];

  const onChange = (key: string) => {
    if (key === CATEGORY_STATUS_TABS.BUSINESS_MANUALS.key) {
      setSearchParams({ tab: key, sub_tab: businessManualSubTab });
    } else {
      setSearchParams({ tab: key });
    }
  };

  const onBusinessManualSubTabChange = (key: string) => {
    setBusinessManualSubTab(key);
    setSearchParams({
      tab: CATEGORY_STATUS_TABS.BUSINESS_MANUALS.key,
      sub_tab: key,
    });
  };

  useEffect(() => {
    if (!tabParams) {
      setSearchParams({ tab: CATEGORY_STATUS_TABS.WORKERS.key });
    } else {
      setActiveKey(tabParams);
      if (tabParams === CATEGORY_STATUS_TABS.BUSINESS_MANUALS.key) {
        setBusinessManualSubTab(
          subTabParams || BUSINESS_MANUALS_SUB_TABS.BUSINESS_MANUALS.key,
        );
      }
    }
  }, [tabParams, subTabParams, setSearchParams]);

  return {
    ...props,
    activeKey,
    onChange,
    businessManualSubTab,
    onBusinessManualSubTabChange,
    displaySize,
    height,
    size,
  };
};

export type Props = ReturnType<typeof useCategoryStatusConfig>;

export default useCategoryStatusConfig;
